import buildBaseApi from './baseApi';

const syncToken = process.env.REACT_APP_ZOHO_SYNC_TOKEN;

const updateApi = buildBaseApi( {
  baseURL: process.env.REACT_APP_UPDATE_API_URL!,
  getToken: () => null,
  handle401: false,
} );

if ( syncToken ) {
  updateApi.addRequestTransform( ( request ) => {
    request.headers['x-sync-token'] = syncToken;
    delete request.headers.Authorization;
  } );
}

export default updateApi;
